import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pointer",
  "use": "icon-pointer-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\" id=\"icon-pointer\">\r\n    <g id=\"icon-pointer_icon\">\r\n        <path class=\"cls-2\" d=\"M69.85,59.38,60.19,47.45,70.83,30.8A7,7,0,0,0,59,23.26L41.29,51c-.63-8.6-2.67-11.68-5.8-13.68A4.25,4.25,0,0,0,31,37.1c-2.25,1.25-3.44,4.37-3.42,6.69L28,69a1.75,1.75,0,0,0,.81,1.44L52.46,85.57a1.76,1.76,0,0,0,2.23-.28L67.95,71C71,68,72.9,63.07,69.85,59.38Z\" />\r\n    </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol